import React from "react"
import { Col, Row } from "react-bootstrap"
import LanguageSelector from "./LanguageSelector";

const Searchbar = (props: { handleChange: (event: any) => void; value: string }) => {
  return (
    <Row className="justify-content-between">
      <Col>
        <div className="input-with-icon-right">
          <input
            className="form-control"
            onChange={props.handleChange}
            placeholder="Search feature types"
            id="searchbar"
            value={props.value}
          />
          <div className="input-icon">
            <i className="modus-icons">search</i>
          </div>
        </div>
      </Col>
      <Col md='auto'>
        <LanguageSelector/>
      </Col>
    </Row>
  )
}

export default Searchbar
